.dialogHeader {
  --ixf-dialog-header-action-width: 32px;
  --ixf-dialog-header-padding-horizontal: var(--ixf-dialog-padding-horizontal);
  --ixf-dialog-header-container-padding: 0 0 var(--ixf-dialog-padding-vertical) 0;

  padding: 0 var(--ixf-dialog-header-padding-horizontal);

  &.withoutBorder {
    .container {
      border-bottom: none;
    }
  }

  .container {
    border-bottom: 1px solid var(--ixf-color-separator);
    padding: var(--ixf-dialog-header-container-padding);

    .title {
      color: var(--ixf-text-tone-md);
      font-family: var(--ixf-font-family-main);
      font-weight: var(--ixf-font-weight-main-medium);
      font-size: 1rem;
      line-height: 1.5rem;
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
      min-width: 0;
      overflow: hidden;

      > * {
        color: var(--ixf-text-tone-md);
        font-family: var(--ixf-font-family-main);
        font-weight: var(--ixf-font-weight-main-medium);
        font-size: 1rem;
        line-height: 1.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
      }
    }

    .action {
      display: flex;
      flex: 0 0 var(--ixf-dialog-header-action-width);
      align-items: center;
      gap: var(--ixf-dialog-header-padding-horizontal);

      &:first-child {
        justify-content: flex-start;
      }

      &:last-child {
        justify-content: flex-end;
      }
    }
  }
}
